module.exports = __webpack_public_path__ + "img/voice_l.1cd770d7.svg";